import { Flex, Group, NumberInput, Select, Text } from "@mantine/core";

/**
 * This is a custom pagination section meant for mantine's <DataTable />
 * @returns The content to be fed into renderPagination={({ state, actions, Controls }) => ()}
 */
export default function DataTablePaginationSection({
  state,
  actions,
  Controls,
  page,
  pageSizeOptions,
  pageSize,
  setPageSize,
}) {
  if (state.totalRecords === 0) {
    return null;
  }

  return (
    <>
      <Controls.Text />
      <Flex justify="flex-end" align="center" gap="lg">
        <Group justify="flex-end">
          <Text>Records per page</Text>
          <Select
            radius="md"
            w={78}
            checkIconPosition="right"
            comboboxProps={{ transitionProps: { transition: "pop", duration: 200 } }}
            rightSection={<></>}
            data={pageSizeOptions.map((s) => String(s))}
            value={String(pageSize)}
            onChange={(value) => value && setPageSize(Number(value))}
          />
        </Group>
        <Group gap="xs">
          <Text size={state.paginationSize}>Jump to page</Text>
          <NumberInput
            hideControls
            radius="md"
            w={60}
            size={state.paginationSize}
            onChange={(page) => typeof page === "number" && actions.setPage(page)}
            min={1}
            max={state.totalPages}
            value={page}
          />
        </Group>
        <Controls.Pagination />
      </Flex>
    </>
  );
}
